import { getApiClient } from '../api-client-factory';
import { API_ENDPOINTS } from '../api-endpoints';
import type { ApiResponse, PaginatedResponse } from '../api-types';
import type { Notification, NotificationListParams } from '@welynk/types';

export type { Notification, NotificationListParams };
export { NotificationType } from '@welynk/types';

// ─── Service ──────────────────────────────────────────────

export class NotificationApiService {
  static async getNotifications(
    params?: NotificationListParams
  ): Promise<PaginatedResponse<Notification>> {
    const client = getApiClient();
    const response = await client.get(API_ENDPOINTS.NOTIFICATIONS.LIST, { params });
    return response.data.data;
  }

  static async getUnreadCount(): Promise<number> {
    const client = getApiClient();
    const response = await client.get<ApiResponse<{ count: number }>>(
      API_ENDPOINTS.NOTIFICATIONS.UNREAD_COUNT
    );
    return response.data.data.count;
  }

  static async markAsRead(notificationIds: string[]): Promise<number> {
    const client = getApiClient();
    const response = await client.patch<ApiResponse<{ updated: number }>>(
      API_ENDPOINTS.NOTIFICATIONS.MARK_READ,
      { notificationIds }
    );
    return response.data.data.updated;
  }

  static async markAllAsRead(): Promise<number> {
    const client = getApiClient();
    const response = await client.patch<ApiResponse<{ updated: number }>>(
      API_ENDPOINTS.NOTIFICATIONS.MARK_ALL_READ
    );
    return response.data.data.updated;
  }
}
